import VacancyRespondForm from './VacancyRespondForm.vue';

export default VacancyRespondForm;



// WEBPACK FOOTER //
// ./src/pages/vacancies/form/index.ts